function SkeletonBar({ className = "" }) {
  return <div className={`animate-pulse rounded-md bg-slate-200/80 ${className}`.trim()} />;
}

function PostCardSkeleton() {
  return (
    <article className="post-box space-y-3 p-3 md:p-5" aria-hidden>
      <SkeletonBar className="h-4 w-20" />
      <SkeletonBar className="h-24 w-full rounded-md" />
      <SkeletonBar className="h-4 w-24" />
      <div className="flex flex-wrap gap-2">
        <SkeletonBar className="h-9 w-24 rounded-md" />
        <SkeletonBar className="h-9 w-28 rounded-md" />
        <SkeletonBar className="h-9 w-20 rounded-md" />
      </div>
      <SkeletonBar className="h-4 w-32" />
      <SkeletonBar className="h-16 w-full rounded-md" />
    </article>
  );
}

export default function PostPreviewSkeletons({ count = 3, label = "Generating posts" }) {
  return (
    <div className="col-md-12" aria-busy="true" aria-label={label}>
      <SkeletonBar className="mx-1 mb-4 h-8 w-56 max-w-full md:mx-2" />
      <SkeletonBar className="mx-1 mb-6 h-4 w-72 max-w-full md:mx-2" />
      <div className="step-container mx-1 space-y-3 md:mx-2 md:space-y-4">
        {Array.from({ length: count }, (_, index) => (
          <PostCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
}
